import React from "react";
import { FiPhone } from "react-icons/fi";

const brands = [
  { name: "Christ University", logo: "/img/christ.png" },
  { name: "Mangalmay Group of Institutions", logo: "/img/mangalmay.png" },
  { name: "Amity University", logo: "/img/amity.png" },
  { name: "Shiv Nadar University", logo: "/img/shivnadar.webp" },
  { name: "Ashoka University", logo: "/img/ashoka.png" },
  { name: "BML Munjal University", logo: "/img/bmu-dark.png" },
  { name: "Bennett University", logo: "/img/bennett-logo.png" },
];

const stats = [
  { value: "4,000+", label: "students served" },
  { value: "1,000+", label: "working professionals" },
  { value: "Since 2016", label: "cooking fresh every day" },
];

const CATERING_PHONE = "7078548120";

const BiggestBrands = () => {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="story-hero-head mb-3 text-base font-bold uppercase tracking-wide text-gray-900 md:text-lg">
            Trusted on campus &amp; at work
          </p>
          <h2 className="story-hero-head text-[2rem] font-bold uppercase leading-[1.1] text-[#1f5c33] sm:text-[2.5rem] md:text-5xl">
            Our Presence
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-gray-700 md:text-base">
            Universities and corporate offices across Delhi NCR trust GreeNox
            to keep their people fuelled with fresh ingredients and balanced
            meals, every single day.
          </p>
        </div>

        <dl className="mx-auto mt-10 grid max-w-3xl grid-cols-3 divide-x divide-[#1f5c33]/15 text-center md:mt-12">
          {stats.map(({ value, label }) => (
            <div key={label} className="flex flex-col-reverse px-2 sm:px-4">
              <dt className="mt-1 text-xs text-gray-600 sm:text-sm">{label}</dt>
              <dd className="story-hero-head text-2xl font-bold text-[#1f5c33] sm:text-4xl">
                {value}
              </dd>
            </div>
          ))}
        </dl>

        {/* Logo files are square with lots of empty space, so each box is
            shorter than the image and clips the blank top and bottom */}
        <ul className="mx-auto mt-10 flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-4 sm:gap-x-12 md:mt-12 md:gap-x-16">
          {brands.map((brand) => (
            <li
              key={brand.name}
              className="flex h-20 w-32 items-center justify-center overflow-hidden sm:h-24 sm:w-40"
            >
              <img
                src={brand.logo}
                alt={brand.name}
                loading="lazy"
                className="h-auto w-full transition duration-300 hover:scale-105"
              />
            </li>
          ))}
        </ul>

        {/* Catering enquiry */}
        <div className="mt-10 flex flex-col items-center gap-5 rounded-3xl bg-gradient-to-br from-[#1f5c33] to-green-700 px-6 py-8 text-center text-white md:mt-12 md:flex-row md:justify-between md:px-10 md:text-left">
          <div>
            <h3 className="story-hero-head text-2xl font-bold uppercase md:text-3xl">
              Corporate &amp; campus catering
            </h3>
            <p className="mt-1 text-sm text-white/80 md:text-base">
              Healthy, balanced meals for your team, event or institution.
            </p>
          </div>
          <a
            href={`tel:+91${CATERING_PHONE}`}
            className="inline-flex h-12 shrink-0 items-center justify-center gap-2 rounded-full bg-white px-7 text-sm font-semibold text-gray-900 shadow-lg transition hover:bg-gray-100"
          >
            <FiPhone aria-hidden="true" />
            Call +91 70785 48120
          </a>
        </div>
      </div>
    </section>
  );
};

export default BiggestBrands;
